import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = ['modal', 'confirm', 'submit']

  connect() {
    this.modal = new Modal(this.modalTarget)
    this.syncSubmit()
  }

  disconnect() {
    this.modal.dispose()
  }

  open() {
    this.modal.show()
  }

  close() {
    this.modal.hide()
  }

  syncSubmit() {
    this.submitTarget.disabled = !this.confirmTargets.every((checkbox) => checkbox.checked)
  }
}
